import styled from 'styled-components'

import { ButtonAddWithLabelUnstyled } from 'Components/Buttons/ButtonAddWithLabel/unstyled'

export const ButtonAddWithLabel = styled(ButtonAddWithLabelUnstyled)`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  background: ${props => props.theme.colors.primary};
  border: none;
  transitions: background-color, 0.3s;
  cursor: pointer;
  &:hover {
    background-color: #fd3758;
  }
  &:focus {
    background-color: #d72b4f;
  }
  &:disabled {
    background-color: #aeafc7;
  }
  svg {
    width: ${props => (props.size === 'small' ? '24px' : '40px')};
    height: ${props => (props.size === 'small' ? '24px' : '40px')};
    padding: ${props => (props.size === 'small' ? '5px' : '10px')};
    &.fill-white {
      fill: ${props => props.theme.colors.white};
    }
    path {
      stroke: ${props => props.theme.colors.white};
    }
  }

  label {
    font-family: 'Proxima Nova', sans-serif;
    font-size: ${props => props.theme.fontSizes.label};
    color: ${props => props.theme.colors.white};
    margin: 0 5px;
  }
`
